import * as React from "react";
var BreakpointName = /* @__PURE__ */ ((BreakpointName2) => {
  BreakpointName2["PHONE"] = "PHONE";
  BreakpointName2["TABLET_PORTRAIT"] = "TABLET_PORTRAIT";
  BreakpointName2["TABLET_LANDSCAPE"] = "TABLET_LANDSCAPE";
  BreakpointName2["DESKTOP"] = "DESKTOP";
  return BreakpointName2;
})(BreakpointName || {});
const MediaQueryContext = React.createContext({});
const useBreakpoint = () => {
  const { currentBreakpoint } = React.useContext(MediaQueryContext);
  return currentBreakpoint;
};
const useIsBreakpoint = (name) => {
  const { currentBreakpoint } = React.useContext(MediaQueryContext);
  return currentBreakpoint === name;
};
const useIsPhone = () => useIsBreakpoint(
  "PHONE"
  /* PHONE */
);
const useIsTabletPortrait = () => useIsBreakpoint(
  "TABLET_PORTRAIT"
  /* TABLET_PORTRAIT */
);
const useIsTabletLandscape = () => useIsBreakpoint(
  "TABLET_LANDSCAPE"
  /* TABLET_LANDSCAPE */
);
const useIsDesktop = () => useIsBreakpoint(
  "DESKTOP"
  /* DESKTOP */
);
const breakpointRange = [
  "PHONE",
  "TABLET_PORTRAIT",
  "TABLET_LANDSCAPE",
  "DESKTOP"
  /* DESKTOP */
];
const useIsAbove = (name) => {
  const { currentBreakpoint } = React.useContext(MediaQueryContext);
  return breakpointRange.indexOf(currentBreakpoint) > breakpointRange.indexOf(name);
};
const useIsBelow = (name) => {
  const { currentBreakpoint } = React.useContext(MediaQueryContext);
  return breakpointRange.indexOf(currentBreakpoint) < breakpointRange.indexOf(name);
};
function WithBreakpoints(Component) {
  const wrappedName = Component.displayName || Component.name || "Component";
  const withBreakpoints = (props) => {
    const currentBreakpoint = useBreakpoint();
    return /* @__PURE__ */ React.createElement(Component, { ...props, currentBreakpoint });
  };
  withBreakpoints.displayName = `WithBreakpoints(${wrappedName})`;
  return withBreakpoints;
}
export {
  BreakpointName,
  WithBreakpoints,
  MediaQueryContext as default,
  useBreakpoint,
  useIsAbove,
  useIsBelow,
  useIsDesktop,
  useIsPhone,
  useIsTabletLandscape,
  useIsTabletPortrait
};
//# sourceMappingURL=MediaQueryContext.js.map
